<script setup>
import { ref } from 'vue'
import { qrCodeService } from "@/services/qrCodeService";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonInput from "@/components/ArgonInput.vue";

const QRCode = ref({
  text: "",
  logoPath: "",
  size: "256",
})

const imageSrc = ref(null);

async function createQRCode() {
  const result = await qrCodeService.createQRCode(QRCode.value);

  // if (result.Success) {
  //   console.log('createQRCode->Api->Success:', result);
  //   imageSrc.value = URL.createObjectURL(new Blob([result.data], { type: 'image/jpeg' }));
  // } else {
  //   console.log('createQRCode->Api->Error:', result.Message, result.Error);
  // }

  imageSrc.value = URL.createObjectURL(result)
}
</script>
<style scoped>
img {
  max-width: 250px;
  height: auto;
  border: 2px solid #ddd;
  border-radius: 8px;
  margin-top: 10px;
}
</style>
<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center">

      </div>
    </div>
    <hr class="horizontal dark" />
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">text</label>
              <argon-input type="text" v-model="QRCode.text" placeholder="Type here..." />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">logoPath</label>
              <argon-input type="text" v-model="QRCode.logoPath" placeholder="Type here..." />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">size</label>
              <argon-input type="text" v-model="QRCode.size" placeholder="Type here..." />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">action</label>
              <div>
                <argon-button color="dark" variant="gradient" @click="createQRCode"><i
                    class="fas fa-plus me-2"></i>Generuj
                  QRCode</argon-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <img :src="imageSrc" alt="API Image" v-if="imageSrc" />
          <p v-else></p>
        </div>
      </div>
    </div>
  </div>
</template>
